import { BasicEvent } from "~app/features/planera/events/BasicEvent";

export class CopyKundorderCompletedEventMessage extends BasicEvent {
    kundorderId: number;
    targetKundorderId?: number;
    validationMessage?: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "CopyKundorderCompletedEventMessage";
    constructor() {
        super(CopyKundorderCompletedEventMessage.$type);
    }
}
